const productTypes = ['FBA', 'Retail', 'STS', 'Robotics', 'Devices'];

const carrierScacs = ['CGOJ', 'ATMI'];

module.exports = { productTypes, carrierScacs };
